import { useEffect, useRef, useState } from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { V2_COLORS } from "@/pages/InvoiceManagement/v2/constants/colors";

interface QuestionComposerProps {
  label: string;
  placeholder: string;
  sending: boolean;
  onSend: (text: string) => void;
  onCancel: () => void;
  plain?: boolean;
}

const card = { backgroundColor: "white", border: `1px solid ${V2_COLORS.border}`, borderRadius: "8px", p: 1.5 } as const;

export default function QuestionComposer({ label, placeholder, sending, onSend, onCancel, plain = false }: QuestionComposerProps) {
  const [text, setText] = useState("");
  const trimmed = text.trim();
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    root.current?.scrollIntoView?.({ block: "center", behavior: "smooth" });
  }, []);

  return (
    <Box ref={root} data-testid="question-composer" sx={plain ? undefined : card}>
      <Typography fontSize="10px" sx={{ color: V2_COLORS.textSecondary, textTransform: "uppercase", letterSpacing: "0.5px" }}>
        {label}
      </Typography>
      <TextField
        value={text}
        onChange={(event) => setText(event.target.value)}
        placeholder={placeholder}
        multiline
        minRows={2}
        fullWidth
        size="small"
        autoFocus
        disabled={sending}
        inputProps={{ maxLength: 500, "aria-label": label }}
        sx={{ mt: 1 }}
      />
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <Button variant="contained" disabled={!trimmed || sending} onClick={() => onSend(trimmed)} sx={{ textTransform: "none", fontWeight: 600 }}>
          Send query
        </Button>
        <Button variant="text" disabled={sending} onClick={onCancel} sx={{ textTransform: "none" }}>
          Cancel
        </Button>
      </Stack>
    </Box>
  );
}
